// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* JIRA Items Styles */

.jira-items-overlay {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-primary, #fff);
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.jira-items-container {
  background-color: var(--bg-primary, white);
  color: var(--text-primary);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.jira-items-container > .back-btn {
  margin: 16px 24px 8px;
  align-self: flex-start;
  flex-shrink: 0;
}

/* Progress Bar Styles */
.sync-progress-container {
  height: 20px;
  width: 60%;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.sync-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #28a745, #34d058);
  border-radius: 10px;
  position: relative;
  transition: width 0.3s ease;
}

.sync-progress-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 45%,
    rgba(255, 255, 255, 0.9) 50%,
    rgba(255, 255, 255, 0.8) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shine 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.jira-items-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color, #e9ecef);
}

.jira-items-title {
  display: flex;
  align-items: center;
  gap: 16px;
}

.jira-items-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary, #212529);
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  color: #495057;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #212529;
}

.back-btn:active {
  background-color: #dee2e6;
  transform: translateY(1px);
}
.generate-all-tests-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e3f2fd;
  color: #0d6efd;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.jira-items-tabs .generate-all-tests-btn {
  margin-right: 2rem;
  align-self: center;
  flex-shrink: 0;
}

.jira-items-tabs .generate-all-scenarios-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  margin-right: 10px;
  align-self: center;
  flex-shrink: 0;
  background-color: #fff3cd;
  color: #fd7e14;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.jira-items-tabs .generate-all-scenarios-btn:hover {
  background-color: #fd7e14;
  color: white;
}

.jira-items-tabs .generate-all-scenarios-btn svg {
  color: currentColor;
}

.jira-items-tabs .generate-all-scenarios-btn:disabled,
.jira-items-tabs .generate-all-tests-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.generate-all-tests-btn:hover {
  background-color: #0d6efd;
  color: white;
}

.generate-all-tests-btn svg {
  color: currentColor;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
 
/* .close-btn:hover {
  background-color: var(--bg-light, #f8f9fa); 
  color: var(--text-primary, #212529);
} */

.jira-items-tabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border-color, #e9ecef);
  padding: 0 24px;
  flex-shrink: 0;
}

.tab-btn {
  padding: 12px 16px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-weight: 500;
  color: var(--text-muted, #6c757d);
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-btn:hover {
  color: var(--text-primary, #212529);
}

.tab-btn.active {
  color: var(--primary, #0d6efd);
  border-bottom-color: var(--primary, #0d6efd);
}

.jira-items-content {
  flex: 1 1;
  min-height: 0;
  padding: 24px;
  overflow-y: auto;
  overflow-x: auto;
}

.stories-list {
  min-width: 0;
}

/* Loading Indicator */
.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: var(--primary, #0d6efd);
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Epics List */
.epics-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.epic-item {
  border: 1px solid var(--border-color, #e9ecef);
  border-radius: 8px;
  overflow: hidden;
}

.epic-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: var(--bg-light, #f8f9fa);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.epic-header:hover {
  background-color: rgba(13, 110, 253, 0.05);
}

.epic-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.jira-key {
  font-family: monospace;
  font-weight: 600;
  color: var(--primary, #0d6efd);
  background-color: rgba(13, 110, 253, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}

.epic-summary {
  font-weight: 500;
}

.epic-meta {
  display: flex;
  align-items: center;
  gap: 16px;
}
.epic-meta-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.epic-action-buttons .generate-scenarios-btn,
.story-action-buttons .generate-scenarios-btn,
.view-scenarios-btn,
.generate-tests-btn {
  height: 32px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.status-badge, .priority-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-done {
  background-color: #e6f4ea;
  color: #28a745;
}

.status-in-progress {
  background-color: #e3f2fd;
  color: #0d6efd;
}

.status-todo {
  background-color: #f8f9fa;
  color: #6c757d;
}

.priority-high {
  background-color: #f8d7da;
  color: #dc3545;
}

.priority-medium {
  background-color: #fff3cd;
  color: #fd7e14;
}

.priority-low {
  background-color: #d1e7dd;
  color: #20c997;
}

.story-points {
  font-weight: 600;
  color: var(--text-muted, #6c757d);
  font-size: 14px;
}

.expand-icon {
  font-size: 12px;
  color: var(--text-muted, #6c757d);
   cursor: pointer;
  margin-left: 8px;
}

.epic-details {
  padding: 16px;
  border-top: 1px solid var(--border-color, var(--border, #e9ecef));
  background-color: var(--surface, #fff);
  color: var(--text-primary, #212529);
}

.epic-description {
  margin-bottom: 16px;
  color: var(--text-primary, #212529);
}

.epic-assignee {
  margin-bottom: 16px;
  color: var(--text-primary, #212529);
}

.epic-stories h4 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #212529);
}

.story-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.story-item {
  padding: 12px;
  border: 1px solid var(--border-color, #e9ecef);
  border-radius: 4px;
  background-color: var(--bg-light, #f8f9fa);
}

.story-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.story-summary {
  font-weight: 500;
}

.story-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Stories Table */
.stories-table {
  width: 100%;
  border-collapse: collapse;
}

.stories-table th{
    padding: 12px;
  text-align: center;
  border-bottom: 1px solid var(--border-color, #e9ecef);
}
.stories-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid var(--border-color, #e9ecef);
}

.stories-table th {
  background-color: var(--bg-light, #f8f9fa);
  font-weight: 600;
  color: var(--text-primary, #212529);
}

.stories-table tr:hover {
  background-color: rgba(13, 110, 253, 0.05);
}

.story-summary-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.story-description {
  font-size: 12px;
  color: var(--text-muted, #6c757d);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.epic-link {
  color: var(--primary, #0d6efd);
  cursor: pointer;
  text-decoration: none;
}

.epic-link:hover {
  text-decoration: underline;
}

.no-items {
  text-align: center;
  color: var(--text-muted, #6c757d);
  padding: 24px;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.view-tests-btn,
.view-tests-btn small{ 
   /* width: 142px; */
 display: flex;
  align-items: center;
  gap: 6px;
  background-color: rgb(241, 216, 216);
  color: #0d6efd;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease; }

.view-scenarios-btn{
  width: 170px;
 display: flex;
  align-items: center;
  gap: 6px;
  background-color: #e2ffd6;
  color: #0d6efd;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease; 
}
.view-tests-btn:hover{
  background-color: rgb(202, 69, 69);
  color: white; 
}
.view-scenarios-btn:hover{
   background-color: #095e33;
  color: white;
}
/* Generate Tests Button Styles */
.generate-tests-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #e3f2fd;
  color: #0d6efd;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.generate-tests-btn:hover {
  background-color: #0d6efd;
  color: white;
}

.generate-tests-btn svg {
  color: currentColor;
}

.generate-tests-btn.small {
  padding: 4px 8px;
  font-size: 12px;
}

/* Generate Scenarios Button Styles */
.generate-scenarios-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #fff3cd;
  color: #fd7e14;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.generate-scenarios-btn:hover {
  background-color: #fd7e14;
  color: white;
}

.generate-scenarios-btn svg {
  color: currentColor;
}

.generate-scenarios-btn.small {
  padding: 4px 8px;
  font-size: 12px;
}

.epic-action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}
/* Action Button Containers */
.epic-action-buttons, .story-action-buttons {
  display: flex;
  gap: 8px;
}

.story-action-buttons.small {
  gap: 4px;
}

/* Test Cases Section */
.saved-test-cases {
  margin-top: 20px;
  border-top: 1px solid var(--border-color, #e9ecef);
  padding-top: 16px;
}

.saved-test-cases h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #212529);
  display: flex;
  align-items: center;
  gap: 8px;
}

.test-case-count {
  background-color: #e3f2fd;
  color: #0d6efd;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .jira-items-overlay {
    top: 56px;
  }

  .epic-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .epic-meta {
    width: 100%;
    justify-content: space-between;
  }
  
  .stories-table {
    display: block;
    overflow-x: auto;
  }
}
.sync-epic-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #0052cc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.sync-jira-btn:hover:not(:disabled) {
  background-color: #0065ff;
}

.sync-jira-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.epic-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: var(--surface-raised, var(--surface, #fff));
  border: 1px solid var(--border, #ddd);
  border-radius: 6px;
  padding: 15px;
  z-index: 1000;
  min-width: 280px;
  box-shadow: var(--shadow-md, 0 4px 15px rgba(0, 0, 0, 0.15));
  color: var(--text-primary, #212529);
}

.epic-dropdown label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: var(--text-primary, #333);
  background: transparent;
}

.epic-dropdown select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 14px;
  background-color: #f9f9f9;
}

.epic-dropdown select:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);
}

.epic-dropdown button {
  width: 100%;
  padding: 10px 15px;
  background-color: #0066cc;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.epic-dropdown button:hover:not(:disabled) {
  background-color: #0052a3;
}

.epic-dropdown button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}


.sync-stories-btn {
  padding: 8px 16px;
  background-color: #0066cc;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease;
}

.sync-stories-btn:hover:not(:disabled) {
  background-color: #0052a3;
}

.sync-stories-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/styles/jira-items.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;;;GAOC;EACD,2DAA2D;AAC7D;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,yCAAyC;EACzC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;;;;EAIE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iCAAiC;GAChC,eAAe;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;IACI,aAAa;EACf,kBAAkB;EAClB,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;;GAEG,kBAAkB;CACpB,aAAa;EACZ,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB,EAAE;;AAE7B;EACE,YAAY;CACb,aAAa;EACZ,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;GACG,yBAAyB;EAC1B,YAAY;AACd;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,6DAA6D;EAC7D,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,4DAA4D;EAC5D,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["/* JIRA Items Styles */\n\n.jira-items-overlay {\n  position: fixed;\n  top: 64px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--bg-primary, #fff);\n  display: flex;\n  flex-direction: column;\n  z-index: 100;\n}\n\n.jira-items-container {\n  background-color: var(--bg-primary, white);\n  color: var(--text-primary);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.jira-items-container > .back-btn {\n  margin: 16px 24px 8px;\n  align-self: flex-start;\n  flex-shrink: 0;\n}\n\n/* Progress Bar Styles */\n.sync-progress-container {\n  height: 20px;\n  width: 60%;\n  background-color: #e0e0e0;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.sync-progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #28a745, #34d058);\n  border-radius: 10px;\n  position: relative;\n  transition: width 0.3s ease;\n}\n\n.sync-progress-bar::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.8) 45%,\n    rgba(255, 255, 255, 0.9) 50%,\n    rgba(255, 255, 255, 0.8) 55%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: shine 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n\n@keyframes shine {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n.jira-items-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n}\n\n.jira-items-title {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.jira-items-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n}\n\n.back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  color: #495057;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.back-btn:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n  color: #212529;\n}\n\n.back-btn:active {\n  background-color: #dee2e6;\n  transform: translateY(1px);\n}\n.generate-all-tests-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #e3f2fd;\n  color: #0d6efd;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.jira-items-tabs .generate-all-tests-btn {\n  margin-right: 2rem;\n  align-self: center;\n  flex-shrink: 0;\n}\n\n.jira-items-tabs .generate-all-scenarios-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  margin-right: 10px;\n  align-self: center;\n  flex-shrink: 0;\n  background-color: #fff3cd;\n  color: #fd7e14;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.jira-items-tabs .generate-all-scenarios-btn:hover {\n  background-color: #fd7e14;\n  color: white;\n}\n\n.jira-items-tabs .generate-all-scenarios-btn svg {\n  color: currentColor;\n}\n\n.jira-items-tabs .generate-all-scenarios-btn:disabled,\n.jira-items-tabs .generate-all-tests-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.generate-all-tests-btn:hover {\n  background-color: #0d6efd;\n  color: white;\n}\n\n.generate-all-tests-btn svg {\n  color: currentColor;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n \n/* .close-btn:hover {\n  background-color: var(--bg-light, #f8f9fa); \n  color: var(--text-primary, #212529);\n} */\n\n.jira-items-tabs {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n  padding: 0 24px;\n  flex-shrink: 0;\n}\n\n.tab-btn {\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-weight: 500;\n  color: var(--text-muted, #6c757d);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tab-btn:hover {\n  color: var(--text-primary, #212529);\n}\n\n.tab-btn.active {\n  color: var(--primary, #0d6efd);\n  border-bottom-color: var(--primary, #0d6efd);\n}\n\n.jira-items-content {\n  flex: 1;\n  min-height: 0;\n  padding: 24px;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.stories-list {\n  min-width: 0;\n}\n\n/* Loading Indicator */\n.loading-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top-color: var(--primary, #0d6efd);\n  animation: spin 1s ease-in-out infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Epics List */\n.epics-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.epic-item {\n  border: 1px solid var(--border-color, #e9ecef);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.epic-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background-color: var(--bg-light, #f8f9fa);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.epic-header:hover {\n  background-color: rgba(13, 110, 253, 0.05);\n}\n\n.epic-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.jira-key {\n  font-family: monospace;\n  font-weight: 600;\n  color: var(--primary, #0d6efd);\n  background-color: rgba(13, 110, 253, 0.1);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.epic-summary {\n  font-weight: 500;\n}\n\n.epic-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.epic-meta-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.epic-action-buttons .generate-scenarios-btn,\n.story-action-buttons .generate-scenarios-btn,\n.view-scenarios-btn,\n.generate-tests-btn {\n  height: 32px;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.status-badge, .priority-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-done {\n  background-color: #e6f4ea;\n  color: #28a745;\n}\n\n.status-in-progress {\n  background-color: #e3f2fd;\n  color: #0d6efd;\n}\n\n.status-todo {\n  background-color: #f8f9fa;\n  color: #6c757d;\n}\n\n.priority-high {\n  background-color: #f8d7da;\n  color: #dc3545;\n}\n\n.priority-medium {\n  background-color: #fff3cd;\n  color: #fd7e14;\n}\n\n.priority-low {\n  background-color: #d1e7dd;\n  color: #20c997;\n}\n\n.story-points {\n  font-weight: 600;\n  color: var(--text-muted, #6c757d);\n  font-size: 14px;\n}\n\n.expand-icon {\n  font-size: 12px;\n  color: var(--text-muted, #6c757d);\n   cursor: pointer;\n  margin-left: 8px;\n}\n\n.epic-details {\n  padding: 16px;\n  border-top: 1px solid var(--border-color, var(--border, #e9ecef));\n  background-color: var(--surface, #fff);\n  color: var(--text-primary, #212529);\n}\n\n.epic-description {\n  margin-bottom: 16px;\n  color: var(--text-primary, #212529);\n}\n\n.epic-assignee {\n  margin-bottom: 16px;\n  color: var(--text-primary, #212529);\n}\n\n.epic-stories h4 {\n  margin-top: 0;\n  margin-bottom: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n}\n\n.story-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.story-item {\n  padding: 12px;\n  border: 1px solid var(--border-color, #e9ecef);\n  border-radius: 4px;\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.story-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.story-summary {\n  font-weight: 500;\n}\n\n.story-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Stories Table */\n.stories-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.stories-table th{\n    padding: 12px;\n  text-align: center;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n}\n.stories-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n}\n\n.stories-table th {\n  background-color: var(--bg-light, #f8f9fa);\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n}\n\n.stories-table tr:hover {\n  background-color: rgba(13, 110, 253, 0.05);\n}\n\n.story-summary-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.story-description {\n  font-size: 12px;\n  color: var(--text-muted, #6c757d);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 300px;\n}\n\n.epic-link {\n  color: var(--primary, #0d6efd);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.epic-link:hover {\n  text-decoration: underline;\n}\n\n.no-items {\n  text-align: center;\n  color: var(--text-muted, #6c757d);\n  padding: 24px;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.view-tests-btn,\n.view-tests-btn small{ \n   /* width: 142px; */\n display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: rgb(241, 216, 216);\n  color: #0d6efd;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease; }\n\n.view-scenarios-btn{\n  width: 170px;\n display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #e2ffd6;\n  color: #0d6efd;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease; \n}\n.view-tests-btn:hover{\n  background-color: rgb(202, 69, 69);\n  color: white; \n}\n.view-scenarios-btn:hover{\n   background-color: #095e33;\n  color: white;\n}\n/* Generate Tests Button Styles */\n.generate-tests-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #e3f2fd;\n  color: #0d6efd;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.generate-tests-btn:hover {\n  background-color: #0d6efd;\n  color: white;\n}\n\n.generate-tests-btn svg {\n  color: currentColor;\n}\n\n.generate-tests-btn.small {\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n/* Generate Scenarios Button Styles */\n.generate-scenarios-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #fff3cd;\n  color: #fd7e14;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.generate-scenarios-btn:hover {\n  background-color: #fd7e14;\n  color: white;\n}\n\n.generate-scenarios-btn svg {\n  color: currentColor;\n}\n\n.generate-scenarios-btn.small {\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n.epic-action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n/* Action Button Containers */\n.epic-action-buttons, .story-action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.story-action-buttons.small {\n  gap: 4px;\n}\n\n/* Test Cases Section */\n.saved-test-cases {\n  margin-top: 20px;\n  border-top: 1px solid var(--border-color, #e9ecef);\n  padding-top: 16px;\n}\n\n.saved-test-cases h3 {\n  margin-top: 0;\n  margin-bottom: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.test-case-count {\n  background-color: #e3f2fd;\n  color: #0d6efd;\n  font-size: 12px;\n  padding: 2px 6px;\n  border-radius: 10px;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .jira-items-overlay {\n    top: 56px;\n  }\n\n  .epic-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .epic-meta {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .stories-table {\n    display: block;\n    overflow-x: auto;\n  }\n}\n.sync-epic-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background-color: #0052cc;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.sync-jira-btn:hover:not(:disabled) {\n  background-color: #0065ff;\n}\n\n.sync-jira-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n.epic-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: var(--surface-raised, var(--surface, #fff));\n  border: 1px solid var(--border, #ddd);\n  border-radius: 6px;\n  padding: 15px;\n  z-index: 1000;\n  min-width: 280px;\n  box-shadow: var(--shadow-md, 0 4px 15px rgba(0, 0, 0, 0.15));\n  color: var(--text-primary, #212529);\n}\n\n.epic-dropdown label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: var(--text-primary, #333);\n  background: transparent;\n}\n\n.epic-dropdown select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  background-color: #f9f9f9;\n}\n\n.epic-dropdown select:focus {\n  outline: none;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);\n}\n\n.epic-dropdown button {\n  width: 100%;\n  padding: 10px 15px;\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.epic-dropdown button:hover:not(:disabled) {\n  background-color: #0052a3;\n}\n\n.epic-dropdown button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n\n.sync-stories-btn {\n  padding: 8px 16px;\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.sync-stories-btn:hover:not(:disabled) {\n  background-color: #0052a3;\n}\n\n.sync-stories-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
